module.exports = __webpack_public_path__ + "assets/img/0218.062068ef.png";